import React from 'react';
import ColumItem from '@components/column-item';
/**
 * コラム一覧の生成
 */
const createColumnElements = (columnItemList) => {
    if (columnItemList.length === 0) {
        return null;
    }
    return columnItemList.map((columnItem, index) => {
        return (React.createElement(ColumItem, { columnItem: columnItem, key: index }));
    });
};
const ColumnItemGroup = ({ columnItemList }) => {
    return (React.createElement("div", { className: "column-item-group" }, createColumnElements(columnItemList)));
};
export default ColumnItemGroup;
